import React from "react";
import { Link } from "react-router-dom";
import Stepper from "containers/Contracts/components/Stepper";
import { FileText, FileStack } from "lucide-react";
import { Card, CardBody, Container } from "reactstrap";
import {
	RowContainer,
	Title,
	Button,
	ButtonContainer,
	ButtonTitle,
	ButtonText,
	IconContainer
} from "./styles";

const ContractSolicitationSelection = () => {
	return (
		<Container className="dashboard">
			<Card>
				<CardBody>
					<Stepper currentStep={1} />

					<RowContainer>
						<Title>Solicitação de Contratos</Title>
					</RowContainer>
					<ButtonContainer>
						<Link to="/contracts/contract-solicitation/new">
							<Button>
								<IconContainer>
									<FileText size={32} color="#312C85" />
								</IconContainer>
								<ButtonTitle>Solicitar novo contrato</ButtonTitle>
								<ButtonText>
									Solicite um novo contrato para um prestador de serviço.
								</ButtonText>
							</Button>
						</Link>
						<Link to="/contracts/bulk-contract-solicitation/new">
							<Button>
								<IconContainer>
									<FileStack size={32} color="#312C85" />
								</IconContainer>
								<ButtonTitle>Solicitar contratos em massa</ButtonTitle>
								<ButtonText>
									Envie uma planilha para solicitar vários contratos de uma só
									vez.
								</ButtonText>
							</Button>
						</Link>
					</ButtonContainer>
				</CardBody>
			</Card>
		</Container>
	);
};

export default ContractSolicitationSelection;
